module.exports = __webpack_public_path__ + "static/img/mobile_01.968fc5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile_01.png
// module id = mrKD
// module chunks = 1